var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTylkodozimnychproduktwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.71 57.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.5 14 14.81 15.49 18.81 17.33 15.53 19.22 16.26 20.48 19.53 18.59 19.13 22.97 20.77 23.12 21.28 17.59 26.63 14.5 26.63 20.67 22.08 23.88 23.03 25.23 26.63 22.69 26.63 26.47 28.08 26.47 28.08 22.69 31.67 25.23 32.62 23.88 28.08 20.67 28.08 14.5 33.43 17.59 33.94 23.12 35.58 22.97 35.17 18.59 38.45 20.48 39.18 19.22 35.9 17.33 39.9 15.49 39.21 14 34.16 16.32 28.81 13.24 34.16 10.15 39.21 12.48 39.9 10.98 35.9 9.14 39.18 7.25 38.45 5.99 35.17 7.88 35.58 3.5 33.94 3.35 33.43 8.89 28.08 11.97 28.08 5.8 32.62 2.59 31.67 1.25 28.08 3.79 28.08 0 26.63 0 26.63 3.79 23.03 1.25 22.08 2.59 26.63 5.8 26.63 11.97 21.28 8.89 20.77 3.35 19.13 3.5 19.53 7.88 16.26 5.99 15.53 7.25 18.8 9.14 14.81 10.98 15.5 12.48 20.55 10.15 25.9 13.24 20.55 16.32 15.5 14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,30.09c0,9.2,5.2,17.18,12.8,21.16v5.88h29.11v-5.88c7.61-3.99,12.8-11.97,12.8-21.16H0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTylkodozimnychproduktwIcon);
export default __webpack_public_path__ + "static/media/Tylko do zimnych produktów_icon.6114846ab2d4a2c7a1fd9aeba03bc8a7.svg";
export { ForwardRef as ReactComponent };